import Vue from "vue";
import MobileDetect from "mobile-detect";
import VueConfig from "vue-configuration";
import VueContentPlaceholders from "vue-content-placeholders";
import VuePullInfiniteScroller from "vue-pull-infinite-scroller";
import axios from "axios";
import * as VueGoogleMaps from "vue2-google-maps";
import Flowit from "./services/flowit/plugin";
import * as config from "./config";
import appConfig from "./settings";
import store from "./store";
import i18n from "./i18n";
import Qs from "qs"; // Axios Dependent
import "vuetify/dist/vuetify.min.css";
import "./plugins/vuetify";
import "./registerServiceWorker";
import "./assets/css/system-variables.css";
import "./assets/css/modals.css";
import Default from "./layouts/Default.vue";
import Clean from "./layouts/Clean.vue";
import VueTheMask from "vue-the-mask";
import SystemConfigPlugin from "./plugins/systemConfig";
import WebSocketPlugin from "./plugins/websocket";
import sessionMonitor from "./services/flowit/sessionMonitor";
import dotenv from 'dotenv';

dotenv.config()

// Check if is a mobile device.
const md = new MobileDetect(window.navigator.userAgent);
const settings = config.app(md.mobile() === null);

// eslint-disable-next-line prefer-destructuring
const router = settings.router;

Vue.component("default-layout", Default);
Vue.component("clean-layout", Clean);

import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts);

Vue.use(VueTheMask);
Vue.use(SystemConfigPlugin);
Vue.use(WebSocketPlugin);
Vue.use(Flowit);
Vue.use(VueContentPlaceholders);
Vue.use(VueConfig, { config: appConfig });
Vue.use(VuePullInfiniteScroller);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDFLhGwK0tG6TgK3ubG-fZtoU-m5J2BV2U",
    libraries: "places" // necessary for places input
  },
  installComponents: true
});

Vue.config.productionTip = false;

axios.defaults.paramsSerializer = function(params) {
  return Qs.stringify(params, {
    arrayFormat: "brackets",
    encode: false
  });
};

Vue.prototype.$http = axios;

// Initialize app with loading state
async function initializeApp() {
  // Create Vue app
  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(settings.layout),
    async created() {
      // System configuration already loaded before app mount
      // Iniciar monitor de sessão se usuário estiver logado
      if (this.$flowit.token.exists()) {
        sessionMonitor.start();
      }
    }
  });

  try {
    // Load system configuration before mounting app with timeout
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Configuration load timeout')), 10000)
    );
    
    await Promise.race([
      app.$store.dispatch('system/fetchSystemConfiguration'),
      timeoutPromise
    ]);
  } catch (error) {
    console.error('❌ Failed to load system configuration:', error);
    console.warn('⚠️ Continuing with default configuration');
    // Continue with default configuration
  }

  // Mount app after configuration is loaded
  app.$mount("#app");
  
  
  // Remove initial loader after app is mounted
  const initialLoader = document.getElementById('initial-loader');
  if (initialLoader) {
    initialLoader.style.opacity = '0';
    initialLoader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => {
      if (initialLoader.parentNode) {
        initialLoader.parentNode.removeChild(initialLoader);
      }
    }, 300);
  }
}

// Initialize the application
initializeApp();
